import { httpClient } from "@/shared/lib/httpClient";
import { BugReport, BugReportListResponse } from "@/shared/types/bugReport";

export interface CreateBugReportParams {
    title: string;
    description: string;
    report_type: "suggestion" | "bug" | "other";
    other_type_text?: string;
    page_url?: string;
    drive_link?: string;
    attachments?: File[];
}

export async function createBugReport(params: CreateBugReportParams): Promise<BugReport> {
    const form = new FormData();
    form.append("title", params.title);
    form.append("description", params.description);
    form.append("report_type", params.report_type);
    if (params.other_type_text) form.append("other_type_text", params.other_type_text);
    if (params.page_url) form.append("page_url", params.page_url);
    if (params.drive_link) form.append("drive_link", params.drive_link);
    for (const file of params.attachments ?? []) {
        form.append("attachments", file);
    }
    return httpClient.uploadFile<BugReport>("/bug-reports", form);
}

export async function listBugReports(
    page = 1,
    perPage = 20,
    status?: string,
    reportType?: string,
): Promise<BugReportListResponse> {
    const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
    if (status) params.set("status", status);
    if (reportType) params.set("report_type", reportType);
    return httpClient.get<BugReportListResponse>(`/admin/bug-reports?${params}`);
}

export async function getBugReport(id: number): Promise<BugReport> {
    return httpClient.get<BugReport>(`/admin/bug-reports/${id}`);
}

export async function updateBugReportStatus(id: number, status: string): Promise<void> {
    return httpClient.patch(`/admin/bug-reports/${id}/status`, { status });
}

export async function getAttachmentBlobUrl(reportId: number, attachmentId: number): Promise<string> {
    const blob = await httpClient.get<Blob>(
        `/admin/bug-reports/${reportId}/attachments/${attachmentId}`,
        { responseType: "blob" } as Parameters<typeof httpClient.get>[1],
    );
    return URL.createObjectURL(blob);
}
